import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 82 82"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { "data-name": "Layer 2" }, [
      _createElementVNode("path", { d: "M41 82a41 41 0 1 1 41-41 41 41 0 0 1-41 41m0-80a39 39 0 1 0 39 39A39.05 39.05 0 0 0 41 2" }),
      _createElementVNode("path", { d: "M32.32 34.9H36v-3.61c0-1.6 0-4.06 1.19-5.58A6.65 6.65 0 0 1 43 23a23.3 23.3 0 0 1 6.67.67l-.93 5.51a12.5 12.5 0 0 0-3-.45c-1.45 0-2.75.52-2.75 2v4.2H49l-.42 5.39H43V59h-7V40.29h-3.68Z" })
    ], -1)
  ]))]))
}
export default { render: render }